module.exports = __webpack_public_path__ + "c909f1dab729ca225dffd64b86491491.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/history/4.jpg
// module id = 276
// module chunks = 0